import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
const SvgGreece = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        style: {
            enableBackground: "new 0 0 512 512"
        },
        xmlSpace: "preserve",
        width: "1em",
        height: "1em",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M268.737 56.648v56.889H512v-1.295c0-20.233-5.367-39.212-14.752-55.594H268.737zM268.74 170.43H512v56.888H268.74zM0 284.2h512v56.889H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#41479b"
                },
                d: "M0 341.09h512v56.889H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M0 400.241c0 19.838 5.165 38.467 14.212 54.628h483.575c9.048-16.161 14.212-34.79 14.212-54.628v-2.261H0v2.261z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#41479b"
                },
                d: "M101.624 511.759h308.751c37.617-3.456 69.845-25.51 87.412-56.889H14.212c17.568 31.379 49.795 53.432 87.412 56.889zM268.737 113.536V56.648h228.511C477.941 22.947 441.623.241 400 .241H112c-61.856 0-112 50.144-112 112v171.961h512v-56.889H268.737V170.424H512v-56.888H268.737z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M269.474 114.019H163.181V.241h-56.888v113.778H0v56.888h106.293v113.778h56.888V170.907h106.293z"
            })
        ]
    });
export { SvgGreece };
